import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  selectAssetsTags, selectSchedulerAssetsTags, selectSchedulerServicesTags,
  selectSchedulerVulnsTags, selectServicesTags, selectVulnsTags
} from 'store/Schedule/selectors';
import EntityTags from 'Screens/Automation/Agents/components/AgentDetail/components/TagsSection/EntityTags';
import { Wrapper, Title, Entities, Edit } from 'Screens/Automation/Agents/components/AgentDetail/components/TagsSection/styled';
import { openModal } from 'store/modals/actions';
import { MODAL_TAGS_IN_AGENTS } from 'store/modals/modals';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TagsSection = ({ isCreateSchedule }) => {
  const dispatch = useDispatch();
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const assetsTags = useSelector(selectSchedulerAssetsTags);
  const vulnsTags = useSelector(selectSchedulerVulnsTags);
  const servicesTags = useSelector(selectSchedulerServicesTags);
  const assetsTagsAdded = useSelector(selectAssetsTags);
  const vulnsTagsAdded = useSelector(selectVulnsTags);
  const servicesTagsAdded = useSelector(selectServicesTags);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'agents.triggerAgent.tags.title' });

  if (!hasTagsFeature) return null;

  return (
    <Wrapper>
      <Title children={ title } />
      <Entities>
        <EntityTags entity="assets" values={ isCreateSchedule ? assetsTags : assetsTagsAdded } />
        <EntityTags entity="vulnerabilities" values={ isCreateSchedule ? vulnsTags : vulnsTagsAdded } />
        <EntityTags entity="services" values={ isCreateSchedule ? servicesTags : servicesTagsAdded } />
      </Entities>
      <Edit id="open-modal-tags-in-agents" onClick={ () => dispatch(openModal(MODAL_TAGS_IN_AGENTS)) }>Edit</Edit>
    </Wrapper>
  );
};

export default TagsSection;
